import { ModuleType } from 'modules/common/types';
import { pages } from './pages';

export const categoryModule: ModuleType = {
	pages,
};
